var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4373_215665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 2.83337C11.3333 2.74496 11.2982 2.66018 11.2357 2.59767C11.1732 2.53515 11.0884 2.50004 11 2.50004H9.33333C8.49408 2.45823 7.6724 2.7503 7.04781 3.31242C6.42323 3.87455 6.04652 4.66103 6 5.50004V7.30003H4.33333C4.24493 7.30003 4.16014 7.33515 4.09763 7.39767C4.03512 7.46018 4 7.54496 4 7.63337V9.3667C4 9.45511 4.03512 9.53989 4.09763 9.6024C4.16014 9.66492 4.24493 9.70004 4.33333 9.70004H6V14.1667C6 14.2551 6.03512 14.3399 6.09763 14.4024C6.16014 14.4649 6.24493 14.5 6.33333 14.5H8.33333C8.42174 14.5 8.50652 14.4649 8.56904 14.4024C8.63155 14.3399 8.66667 14.2551 8.66667 14.1667V9.70004H10.4133C10.4875 9.7011 10.5598 9.67742 10.619 9.63275C10.6782 9.58808 10.7207 9.52496 10.74 9.45337L11.22 7.72004C11.2333 7.67078 11.235 7.61914 11.2252 7.5691C11.2154 7.51905 11.1942 7.47192 11.1633 7.43135C11.1324 7.39078 11.0926 7.35784 11.0469 7.33507C11.0013 7.31231 10.951 7.30032 10.9 7.30003H8.66667V5.50004C8.68325 5.33502 8.76074 5.18211 8.88402 5.07116C9.00729 4.96022 9.16749 4.8992 9.33333 4.90004H11C11.0884 4.90004 11.1732 4.86492 11.2357 4.8024C11.2982 4.73989 11.3333 4.65511 11.3333 4.5667V2.83337Z",
    fill: "#D1D1D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4373_215665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a20ed7edf4d0e91386fff8ed723d735f.svg";
export { ForwardRef as ReactComponent };